'use client';

import { Toaster } from 'react-hot-toast';

const pulseKeyframes = `
@keyframes toast-pulse {
  0% { transform: scale(1); }
  10% { transform: scale(1.06); }
  20% { transform: scale(1); }
  30% { transform: scale(1.04); }
  40% { transform: scale(1); }
  100% { transform: scale(1); }
}
`;

export default function ClientToaster() {
  return (
    <>
      <style>{pulseKeyframes}</style>
      <Toaster
        toastOptions={{
          duration: 8000,
          style: {
            fontSize: '1.1rem',
            padding: '1rem 1.5rem',
            maxWidth: '480px',
            animation: 'toast-pulse 2s ease-out',
          },
        }}
      />
    </>
  );
}